import { AfterContentInit, Component, Inject, Input, LOCALE_ID, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { isSameDay } from 'date-fns';
import * as _ from 'lodash';
import moment from 'moment';
import { Subject, forkJoin } from 'rxjs';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { EInterventionStatus } from 'src/app/domain/enum/intervention-status';
import { EMeasureParentType } from 'src/app/domain/enum/measure-parent-type';
import { ETimeSlot } from 'src/app/domain/enum/time-slot';
import { Intervention } from 'src/app/domain/intervention';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { InterventionService } from 'src/app/services/intervention.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { BaseComponent } from '../base/base.component';
import { ECalendarType } from './calendar-type.model';
import { CalendarModel } from './calendar.model';
import { EZoneUsage } from 'src/app/domain/enum/zone-usage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-intervention-list',
    templateUrl: './intervention-list.component.html',
    styleUrls: ['./intervention-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InterventionListComponent extends BaseComponent implements OnInit, AfterContentInit {
    ECalendarType = ECalendarType;
    EMeasureParentType = EMeasureParentType;
    private previousWeekNumber: number;
    lodash = _;
    AvailableInterventionList: Intervention[] = [];
    FilteredInterventionList: Intervention[] = [];
    // Model: Intervention[][] = [];
    Model: CalendarModel[] = [];

    SamplingPointInterventionList: Intervention[] = [];
    InterventionStatusMode = 2;

    @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
    DisplayCalendarMode: boolean = false;
    CalendarView = CalendarView;
    view: CalendarView = CalendarView.Month;
    viewDate: Date = new Date();

    events: CalendarEvent<{ id: number }>[] = [];
    refresh: Subject<any> = new Subject();
    activeDayIsOpen: boolean = false;

    @Input() locale: string;

    constructor(
        protected coreData: CoreData,
        private interventionService: InterventionService,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        @Inject(LOCALE_ID) locale: string,
        private dialog: MatDialog) {
        super(coreData)
        this.locale = locale;
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        const strategyId = Number(this.route.snapshot.params['strategyId']);
        if (this.IsDispatch) {
            if (strategyId > 0)
                this.getInterventionByStrategyId(strategyId);
            else
                this.getInterventionInPending();

            return;
        }
        this.getInterventionInProgress();
    }

    getTimeSlotName(timeSlot: ETimeSlot) {
        return StringConverter.getTimeSlotName(timeSlot);
    }

    getInterventionByStrategyId(strategyId: number) {
        this.AvailableInterventionList = this.FilteredInterventionList = this.Model = [];

        this.interventionService.getInterventionByStrategyId(strategyId).subscribe((list) => {
            this.AvailableInterventionList = list;
            this.AvailableInterventionList = this.FilteredInterventionList = _.orderBy(this.AvailableInterventionList, x => x.PlannedOn);
            this.buildCalendarModelList();
            this.buildCalendar();
            this.getSamplingPointList();
        });
    }

    getInterventionInPending() {
        this.AvailableInterventionList = this.FilteredInterventionList = this.Model = [];

        this.interventionService.getInterventionInPending().subscribe((list) => {
            this.AvailableInterventionList = list;
            this.AvailableInterventionList = this.FilteredInterventionList = _.orderBy(this.AvailableInterventionList, x => x.PlannedOn);
            this.buildCalendarModelList();
            this.buildCalendar();
            this.getSamplingPointList();
        });
    }

    getInterventionInProgress() {
        this.AvailableInterventionList = this.FilteredInterventionList = this.Model = [];

        forkJoin([
            this.interventionService.getInterventionInProgress(),
            this.interventionService.getInterventionCanceled()
        ]).subscribe(([A, B]) => {
            this.AvailableInterventionList.push(...A, ...B);
            this.AvailableInterventionList = this.FilteredInterventionList = _.orderBy(this.AvailableInterventionList, x => x.PlannedOn);
            this.buildCalendarModelList();
            this.buildCalendar();
            this.getSamplingPointList();
        });
    }

    getSamplingPointList() {
        this.SamplingPointInterventionList = _.uniqBy(this.AvailableInterventionList, x => x.StrategyId);
        this.SamplingPointInterventionList.forEach(x => x.IsSelected = true);
    }

    toggleSamplingPointSelection(i: Intervention) {
        i.IsSelected = !i.IsSelected;
        this.FilteredInterventionList = this.AvailableInterventionList.filter(x => _.find(this.SamplingPointInterventionList, y => y.StrategyId === x.StrategyId).IsSelected);
        // if ()
        this.buildCalendarModelList();
        this.buildCalendar();
    }

    selectAllStrategy() {
        this.SamplingPointInterventionList.forEach(x => x.IsSelected = true);
        this.FilteredInterventionList = this.AvailableInterventionList.filter(x => _.find(this.SamplingPointInterventionList, y => y.StrategyId === x.StrategyId).IsSelected);
        this.buildCalendarModelList();
        this.buildCalendar();
    }

    deselectAllStrategy() {
        this.SamplingPointInterventionList.forEach(x => x.IsSelected = false);
        this.FilteredInterventionList = this.AvailableInterventionList.filter(x => _.find(this.SamplingPointInterventionList, y => y.StrategyId === x.StrategyId).IsSelected);
        this.buildCalendarModelList();
        this.buildCalendar();
    }

    getInterventionNewed() {
        this.AvailableInterventionList = this.FilteredInterventionList = this.Model = [];
        this.interventionService.getInterventionNewed().subscribe(x => {
            this.AvailableInterventionList = this.FilteredInterventionList = _.orderBy(x, x => x.RequiredOn);
            this.buildCalendarModelList();
            this.buildCalendar();
            this.getSamplingPointList();
        });
    }

    buildCalendar() {
        this.events = [];
        for (let i = 0; i < this.FilteredInterventionList.length; i++) {
            for (let j = 0; j < this.FilteredInterventionList[i].MeasureList.length; j++) {

                let event = {
                    title: `${this.FilteredInterventionList[i].MeasureList[j].MeasureReferenceDesignation} - ${this.FilteredInterventionList[i].MeasureList[j].ParentName}`,
                    color: {
                        primary: this.FilteredInterventionList[i].MeasureList[j].Color,
                        secondary: this.FilteredInterventionList[i].MeasureList[j].Color
                    },
                    start: this.InterventionStatusMode === 1 ? this.FilteredInterventionList[i].RequiredOn : this.FilteredInterventionList[i].PlannedOn,
                    meta: {
                        id: this.FilteredInterventionList[i].MeasureList[j].SamplingId,
                    }
                };

                this.events.push(event);
            }
        }
    }

    buildCalendarModelList() {
        this.Model = [];
        // let currentMonthList: Intervention[] = [];
        // let currentWeekList: Intervention[] = [];

        for (let i = 0; i < this.FilteredInterventionList.length; i++) { // List every intervention
            // currentthis.FilteredInterventionList[i];
            // let wn = this.getWeekNumber(this.FilteredInterventionList[i].RequiredOn);
            // this.FilteredInterventionList[i].wn = wn;
            let date: Date, previousDate: Date;
            if (this.InterventionStatusMode === 1) {
                date = this.FilteredInterventionList[i].RequiredOn;
                previousDate = this.FilteredInterventionList[i - 1]?.RequiredOn ?? new Date;
            } else {
                date = this.FilteredInterventionList[i].PlannedOn;
                previousDate = this.FilteredInterventionList[i - 1]?.PlannedOn ?? new Date;
            }

            if (i >= 0 && (date.getMonth() !== previousDate.getMonth() || date.getFullYear() !== previousDate.getFullYear())) {
                let monthTitle = new CalendarModel();
                monthTitle.Type = ECalendarType.NewMonth;
                monthTitle.Data = this.FilteredInterventionList[i];
                monthTitle.Date = date;
                this.Model.push(monthTitle);
                // currentMonthList = [];
            }
            if (this.IsNewWeek(date)) {
                let weekTitle = new CalendarModel();
                weekTitle.Type = ECalendarType.NewWeek;
                weekTitle.Data = this.FilteredInterventionList[i];
                weekTitle.Date = date;
                this.Model.push(weekTitle);
                // currentMonthList = [];
            }

            let event = new CalendarModel();
            event.Type = ECalendarType.Event;
            event.Data = this.FilteredInterventionList[i];
            event.Date = date;
            this.Model.push(event);
        }

        // this.Model.push(currentMonthList);
    }

    hasSameSamplingPointName(samplingId1: number, samplingId2: number) {
        return this.FilteredInterventionList.find(x => x.MeasureList.some(y => y.SamplingId === samplingId1))?.SamplingPoint.Name === this.FilteredInterventionList.find(x => x.MeasureList.some(y => y.SamplingId === samplingId2))?.SamplingPoint.Name;
    }

    getSamplingPointBySamlingId(samplingId) {
        return this.FilteredInterventionList.find(x => x.MeasureList.some(y => y.SamplingId === samplingId))?.SamplingPoint.Name;
    }

    getFirstDayOfTheWeek(date: Date) {
        return moment(date).startOf('isoWeek').toDate();
    }

    getLastDayOfTheWeek(date: Date) {
        return moment(date).endOf('isoWeek').toDate();
    }

    getInterventionColor(measure: ClientMeasure) {
        if (measure.SampleCode) {
            return '#F5822B';
        }
    }

    IsNewWeek(date: Date) {
        if (this.getWeekNumber(date) !== this.previousWeekNumber) {
            this.previousWeekNumber = this.getWeekNumber(date);
            return true;
        }
        return false;
    }

    getWeekNumber(d: Date) {
        return moment(d).isoWeek();
    }

    navigateToOrder(int?: Intervention) {
        if (int && int.Status !== EInterventionStatus.Canceled) {
            this.router.navigate([ENavigationRoute.Order, {
                id: int.StrategyId,
                interventionId: int.Id
            }]);
        }
    }

    FlattenClientMeasure(list: ClientMeasure[]) {
        return _.uniqBy(list, x => x.ParentName);
    }

    GetCountOfSameClientMeasure(m: ClientMeasure, list: ClientMeasure[]) {
        return _.filter(list, x => x.ParentName === m.ParentName).length;
    }

    getMeasureFullName(m: ClientMeasure) {
        // if (m.IsExotic) {
        return `${m.ParentName}`;
        // }
        // return `${m.MeasureReferenceDesignation} ${m.ParentName}`;
    }

    getColorByUasge(m: ClientMeasure) {
        switch (m.ZoneUsage) {
            case EZoneUsage.PreWork:
                return '#96aff2';
            case EZoneUsage.Environmental:
                return '#0072bc';
            case EZoneUsage.PostWork:
                return '#3fb096';
            default:
                return 'pink'
        }
    }

    hasQuiteSameDateForCalendar(events: []) {
        return events.length === 0 || events.some((e: any) => this.hasQuiteSameDate(
            this.FilteredInterventionList.find(x => x.MeasureList.some(y => y.SamplingId === e.meta.id))?.RequiredOn,
            this.FilteredInterventionList.find(x => x.MeasureList.some(y => y.SamplingId === e.meta.id))?.PlannedOn));
    }

    hasQuiteSameDate(date1: Date, date2: Date) {
        if (!date2) {
            return;
        }

        return date1.getDate() - date2.getDate() === 0;
    }
    /// CALENDAR 

    comparateDateAndTimeSlot(date1: Date, date2: Date, compareWithDate1, timeSlot: ETimeSlot) {
        var startDate = moment(compareWithDate1 ? date1 : date2);
        startDate.hours(timeSlot === ETimeSlot.Morning ? 0 : 12);
        startDate.minutes(0);
        var endDate = moment(compareWithDate1 ? date1 : date2);
        endDate.hours(timeSlot === ETimeSlot.Morning ? 11 : 23);
        endDate.minutes(59);

        return date1.getDate() - date2.getDate() === 0 && moment(compareWithDate1 ? date1 : date2).isBetween(startDate, endDate);
    }

    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        // if (isSameMonth(date, this.viewDate)) {
        if (
            (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
            events.length === 0
        ) {
            this.activeDayIsOpen = false;
        } else {
            this.activeDayIsOpen = true;
        }
        this.viewDate = date;
        // }
    }

    handleEvent(action: string, event: CalendarEvent): void {
        if (action === 'Clicked') {
            this.navigateToOrder(this.FilteredInterventionList.find(x => x.MeasureList.some(y => y.SamplingId === event.meta.id)));
        }

    }

    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
    }
    ///
}
